module.exports = __webpack_public_path__ + "img/transport.eec25660.png";